<template>
  <div class="content">
    <h1>Dashboard</h1>

    <div class="md-layout" v-if="is_staff">
      <div class="md-layout-item">
        <md-field>
          <label for="sources">Sources</label>
          <md-select v-model="selectedSource" @md-selected="onSourceSelect($event)">
            <md-option value="all">All</md-option>
            <md-option v-for="source in sources" :value="source.id">{{source.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout">

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <PieHTTPP2P
          title="Last 15 minutes"
          :labels="['HTTP', 'P2P']"
          :dimension="model.recentChunks.dimension"
          :updated_at="model.recentChunks.updated_at"
          :dataList="model.recentChunks.dataList"
        ></PieHTTPP2P>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <PieHTTPP2P
          title="Daily total in Terabytes"
          :labels="['HTTP', 'P2P']"
          :dimension="model.recentChunks.dimensionTB"
          :updated_at="model.recentSourceStats.updated_at"
          :dataList="model.recentSourceStats.dailyDataList"
        ></PieHTTPP2P>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <PieHTTPP2P
          title="Monthly total in Terabytes"
          :labels="['HTTP', 'P2P']"
          :dimension="model.recentChunks.dimensionTB"
          :updated_at="model.recentSourceStats.updated_at"
          :dataList="model.recentSourceStats.monthlyDataList"
        ></PieHTTPP2P>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <LineChart
          title="People Online"
          :labels="model.peopleOnline.peopleOnlineLabels"
          :peopleOnlineDataSet="model.peopleOnline.peopleOnlineDataSet"
          :updated_at="model.peopleOnline.updated_at"
        ></LineChart>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
        <WorldMapChart
          title="Last 15 minutes trafic"
          :dataList="model.recentChunks.peoplePerCountry"
          :updated_at="model.recentChunks.updated_at"
        ></WorldMapChart>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { API } from '../services';
  import PieHTTPP2P from "../components/Charts/PieHTTPP2P.vue";
  import WorldMapChart from "../components/Charts/WorldMapChart.vue";
  import LineChart from "../components/Charts/LineChart.vue";

  import moment from 'moment';
  import {_} from 'vue-underscore';

  export default {
    name: '',
    components: {
      PieHTTPP2P,
      WorldMapChart,
      LineChart
    },
    data() {
      return {
        intervals: [],
        sources: [],
        selectedSource: 'all',
        model: {
          recentChunks: {
            chunks: [],
            dimension: 'Megabytes',
            dimensionGB: 'Gigabytes',
            dimensionTB: 'Terabytes',
            dataList: [0, 0],
            peoplePerCountry: {},
          },
          peopleOnline: {
            peopleOnlinePerSource: [],
            peopleOnlineLabels: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
            peopleOnlineDataSet: [{
              label: "People Online",
              backgroundColor: "rgba(255, 99, 132, 0.1)",
              borderColor: "rgba(255, 99, 132, 1)",
              borderWidth: 0.7,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }],
            updated_at: 'loading',
          },
          recentSourceStats: {
            sourceStats: [],
            dailyDataList: [0, 0],
            monthlyDataList: [0, 0],
            updated_at: 'loading',
          },
          historicalSourceStats: {
            sourceStats: [],
            dataList: [0, 0],
            updated_at: 'loading',
          }
        }
      }
    },
    created() {
      if (this.is_authenticated){
        this.getData();
      }
      else {
         this.$router.push("login")
       }      
    },
    beforeDestroy() {
        this.intervals.forEach(function (interval) {
          window.clearInterval(interval)
      })
    },
    mounted: function () {
      var self = this;
      this.intervals.push(window.setInterval(() => {
        this.getData();
      }, 200000))
    },
    computed: {
      ...mapGetters(["is_authenticated", "is_staff", "get_sources"]), 
    },
    methods: {
      getData () {
        this.getRecentChunks();
        this.getRecentSourceStats();
        this.getPeopleAmountPerSource();
        this.getSources();
      },
      bytesToSize(bytes, size) {
        var sizes = {
          'BS': 1,
          'KB': 1024,
          'MB': 1024 * 1024,
          'GB': 1024 * 1024 * 1024,
          'TB': 1024 * 1024 * 1024 * 1024,
          'PB': 1024 * 1024 * 1024 * 1024 * 1024,
        }
        if (bytes == 0) return 0;
        return Math.round((bytes/sizes[size])*10)/10;
      },
      totalize(data, property) {
        return data.reduce(function(tot, record) {
          return tot + parseInt(record[property]);
        }, 0);
      },
      getRecentChunks() {
        var self = this;
        API.getLastChunks().then((response) => {
          if (self.selectedSource != 'all') {
            response.data = response.data.filter(
              data => data.source.includes(self.sources.find(x => x.id == self.selectedSource).name)
            );
          }
          self.model.recentChunks.chunks = response.data;

          const http_giga = self.bytesToSize(self.totalize(response.data, 'total_size_http'), 'GB');
          const p2p_giga = self.bytesToSize(self.totalize(response.data, 'total_size_p2p'), 'GB');
          if (http_giga < 1 && p2p_giga < 1 ){
            self.model.recentChunks.dimension = 'Megabytes';
            self.model.recentChunks.dataList[0] = self.bytesToSize(self.totalize(response.data, 'total_size_http'), 'MB');
            self.model.recentChunks.dataList[1] = self.bytesToSize(self.totalize(response.data, 'total_size_p2p'), 'MB');  
          } else {
            self.model.recentChunks.dimension = 'Gigabytes';
            self.model.recentChunks.dataList[0] = http_giga;
            self.model.recentChunks.dataList[1] = p2p_giga;
          }

          // Data for People Per Country Chart
          self.model.recentChunks.peoplePerCountry = {};
          response.data.reduce(function(r, o) {
            if (o.amount_per_country > 10000) {
              console.log(o.amount_per_country)
            }
            if(!self.model.recentChunks.peoplePerCountry[o.country]) {
              self.model.recentChunks.peoplePerCountry[o.country] = parseInt(o.amount_per_country);
            } else {
              self.model.recentChunks.peoplePerCountry[o.country] += parseInt(o.amount_per_country);
            }
          }, []);

          self.model.recentChunks.updated_at = moment(String(new Date())).format('DD/MM/YYYY hh:mm:ss');
        })
      },
      getPeopleAmountPerSource() {
        var self = this;
        API.getPeopleAmountPerSource().then((response) => {
          // Data for People Online Chart
          self.model.peopleOnline.peopleOnlinePerSource = response.data;
          self.model.peopleOnline.peopleOnlineLabels = [];
          self.model.peopleOnline.peopleOnlineDataSet[0].data = [];
          response.data.reverse().forEach(function(record) {
            self.model.peopleOnline.peopleOnlineLabels.push(moment(record.created_at).format('DD/MM/YYYY hh:mm'));
            self.model.peopleOnline.peopleOnlineDataSet[0].data.push(record.total_amount);
          });
          self.model.peopleOnline.updated_at = moment(String(new Date())).format('DD/MM/YYYY hh:mm:ss');
        })
      },
      getRecentSourceStats() {
        var self = this;
        API.getMonthlySourceStats().then((response) => {

          if (self.selectedSource != 'all') {
            response.data = response.data.filter(
              data => data.source_id == self.selectedSource
            );
          }

          self.model.recentSourceStats.sourceStats = response.data;

          const todayDatetimeFrom = moment().startOf('day').format('YYYY-MM-DD hh:mm');
          var dailySourceStats = response.data.filter(function(record){
            return (record.datetime_from >= todayDatetimeFrom && record.interval == '1h');
          });
          self.model.recentSourceStats.dailyDataList[0] = self.bytesToSize(
            self.totalize(dailySourceStats, 'size_http'), 'TB');
          self.model.recentSourceStats.dailyDataList[1] = self.bytesToSize(
            self.totalize(dailySourceStats, 'size_p2p'), 'TB');

          const monthDatetimeFrom = moment().startOf('month').format('YYYY-MM-DD hh:mm');
          var monthlySourceStats = response.data.filter(function(record){
            return (record.datetime_from >= monthDatetimeFrom && record.interval == '1h');
          });
          self.model.recentSourceStats.monthlyDataList[0] = self.bytesToSize(
            self.totalize(monthlySourceStats, 'size_http'), 'TB');
          self.model.recentSourceStats.monthlyDataList[1] = self.bytesToSize(
            self.totalize(monthlySourceStats, 'size_p2p'), 'TB');

          self.model.recentSourceStats.updated_at = moment(String(new Date())).format('DD/MM/YYYY hh:mm:ss');
        })
      },
      onSourceSelect(option) {
        this.getData();
      },
      getSources() {
        API.getAdminSources().then(
          response => {
            this.sources = response.data
          },
        );
      },
    }
  };
</script>
